module.exports = __webpack_public_path__ + "static/img/8600a274.afb1fa0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/rollImg/rollSale/8600a274.jpg
// module id = pp3w
// module chunks = 0